// packages & modules:
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import URL from '../modules/url'
import assets from 'modules/assets'
import * as actions from '../actions'
import * as ourStory from 'modules/ourStory'
import * as getInvolved from 'modules/getInvolved'

// generic
import Spinner from 'components/Utils/Spinner'
import TopWrapper from 'components/Utils/TopWrapper'
import Footer from 'components/Utils/Footer'
import RowThreeText from 'components/Utils/RowThreeText'
import LargeQuote from 'components/Utils/LargeQuote'
import GetInvolvedRows from 'components/Utils/GetInvolvedRows'
import RowFour from 'components/Utils/RowFour'
import AlertMini from 'components/Utils/AlertMini'

import GakkoFamily from './OurStory/GakkoFamily'


class OurStory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      alertIsMinimized: this.props.alertIsMinimized
    }
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView()

    let url = URL(this.props)
    this.props.dispatch(actions.token.fetchData(url))

    // team
    let team = assets('team/index.md')
    this.props.dispatch(actions.token.fetchTeamData(team))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  render() {
    let intro, timeline, largeQuote, vision, ourStudios, team, teamSF, teamNY, teamJap, advisors, hinoki, links
    if (this.state.data && this.state.teamData) {
      intro = ourStory.intro()
      timeline = ourStory.timeline(this.state.data)
      largeQuote = ourStory.largeQuote(this.state.data)
      vision = ourStory.vision(this.state.data)
      ourStudios = ourStory.ourStudios(this.state.data)
      teamSF = ourStory.team(this.state.teamData, ourStory.teams.SF)
      teamNY = ourStory.team(this.state.teamData, ourStory.teams.NY)
      teamJap = ourStory.team(this.state.teamData, ourStory.teams.JAP)
      advisors = ourStory.advisors(this.state.teamData)
      hinoki = ourStory.hinoki(),
      links = getInvolved.links(this.state.data)
    }

    if (this.state && this.state.isFetching) {
      return <main className="about"><Spinner /></main>
    } else {
      return (
        <main className="page fade-in">
          <AlertMini alertIsMinimized={true} />
          <div className="group0 parallax__group">
            <div className="layer parallax__layer--deep">
              <img src={assets('images/blobs/05.png')} style={{width: '100%', height: 'auto'}} />
            </div>
            <div className="layer parallax__layer--base">
              <RowThreeText data={intro} />
              <div className="center">
                <div className="gakko-video">
                  <iframe height="100%" src="https://www.youtube.com/embed/ERVntsa82LU" frameBorder="0" allowFullScreen></iframe>
                </div>
              </div>
              <RowThreeText data={largeQuote} />
              <RowThreeText data={vision} />
              <img className="center" src={assets('images/blobs/03.png')} style={{width: '100%', height: 'auto'}} />
              <RowThreeText data={ourStudios} />
              <RowFour data={teamSF} />
              <RowFour data={teamNY} />
              <RowFour data={teamJap} />
              <RowFour data={advisors} />
              <GakkoFamily data={this.state.data} />
              <GetInvolvedRows data={links} />
              <div className="filler" style={{height: '1px', marginBottom: '15vmax'}}></div>
              <Footer />
            </div>
          </div>
        </main>
      )
    }
  }
}
OurStory.contextTypes = {
}
OurStory.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    isFetching: state.token.isFetching,
    data: state.token.data,
    fetchingTeamData: state.token.fetchingTeamData,
    teamData: state.token.teamData
  }
}

export default connect(mapStateToProps)(OurStory)



// WEBPACK FOOTER //
// ./src/components/OurStory.js